import React from 'react';

type BarcodeProps = {
  barcodeBase64: string;
};

export const Barcode = ({ barcodeBase64 }: BarcodeProps) => {
  if (!barcodeBase64) return null;
  return <img src={`data:image/png;base64,${barcodeBase64}`} alt="Barcode" />;
};
